export const ITEM_DETAILS = 'ITEM_DETAILS';
export const ABOUT_SELLER = 'ABOUT_SELLER';
export const CUSTOMIZATION = 'CUSTOMIIZATION';
export const SHIPPING_RETURNS = 'SHIPPING_RETURNS';
export const BUYER_INCENTIVES = 'BUYER_INCENTIVES';

export const labelMap: Record<string, string> = {
    [ITEM_DETAILS]: ITEM_DETAILS,
    //story telling modules
    'iconic design': 'ABOUT_DESIGN',
    creator: 'ABOUT_DESIGNER',
    [CUSTOMIZATION]: CUSTOMIZATION,
    [ABOUT_SELLER]: ABOUT_SELLER,
    [SHIPPING_RETURNS]: SHIPPING_RETURNS,
    [BUYER_INCENTIVES]: 'The 1stDibs Promise',
};
